// @ts-check

import React from 'react'

export function MyComponent() {
  return <blockquote>Quote</blockquote>
}